/* Sleek game pop-up: game flow (levels, shuffle, picks, checkpoints) */
(function () {
  var G = window.SleekGame;
  if (!G || !G.C) return;
  var T = G.T;

  function alive(run) { return G.open_ && G.S.run === run; }

  G.startRun = function () {
    G.runSeq = (G.runSeq || 0) + 1;
    G.S = { run: G.runSeq, level: 1, held: 0, cleared: 0, saveUsed: false, busy: false };
    G.viewGame();
    G.track('start');
    G.playLevel();
  };

  G.playLevel = async function () {
    var S = G.S, run = S.run, l = S.level, cfg = G.lvl(l);
    S.busy = true;
    S.phase = 'watch';
    G.closeModal();
    G.renderHead();
    G.renderRail();
    G.foot('locked');
    G.buildPieces(cfg, G.colorFor(l));
    var ps = G.body.querySelector('.sg-ps');
    G.say(cfg.decoy ? 'WATCH CLOSELY . DECOY ROUND' : 'WATCH CLOSELY', cfg.decoy ? T.decoy : T.watch);
    await G.wait(250);
    if (!alive(run)) return;
    ps.classList.add('watch');
    G.P.forEach(function (p) { G.lift(p, true); });
    await G.wait(cfg.decoy ? 2100 : 1500);
    if (!alive(run)) return;
    G.P.forEach(function (p) { G.lift(p, false); });
    ps.classList.remove('watch');
    await G.wait(500);
    if (!alive(run)) return;
    S.phase = 'shuffle';
    G.say(cfg.fake ? T.shuffle + ' . FAKE OUTS' : T.shuffle, 'Stay with it.');
    await G.shuffle(cfg, run);
    if (!alive(run)) return;
    S.phase = 'pick';
    S.busy = false;
    G.say('YOUR PICK', T.pick);
    G.foot('pick');
    G.P.forEach(function (p) {
      p.el.disabled = false;
      p.el.onclick = function () { G.onPick(p); };
    });
    try { G.P[0].el.focus({ preventScroll: true }); } catch (e) {}
  };

  function at(slot) { return G.P.filter(function (p) { return p.slot === slot; })[0]; }

  G.shuffle = async function (cfg, run) {
    var d = G.reduced() ? Math.max(cfg.dur, 380) : cfg.dur;
    for (var k = 0; k < cfg.swaps; k++) {
      if (!alive(run)) return;
      var r = G.rand(10);
      if (cfg.fake && r < 2) {
        var hp = G.pickOne(G.P);
        hp.el.style.transitionDuration = Math.round(d * 0.6) + 'ms';
        hp.el.classList.add('hop');
        G.sfx.tick();
        await G.wait(d * 0.6);
        hp.el.classList.remove('hop');
        await G.wait(d * 0.6);
        continue;
      }
      if (cfg.rows && r >= 8) {
        var dir = G.rand(2) ? 1 : -1;
        G.P.forEach(function (p) {
          var ns = (p.slot + dir + G.n) % G.n;
          p.el.classList.toggle('back', Math.abs(ns - p.slot) > 1);
          p.slot = ns;
        });
        G.place(d);
        G.sfx.tick();
        await G.wait(d + 50);
        G.P.forEach(function (p) { p.el.classList.remove('back'); });
        continue;
      }
      var a = G.rand(G.n), b;
      do { b = G.rand(G.n); } while (b === a);
      var pa = at(a), pb = at(b);
      pa.slot = b;
      pb.slot = a;
      pa.el.classList.add('sa');
      pb.el.classList.add('sb');
      G.place(d);
      G.sfx.tick();
      await G.wait(d + 50);
      pa.el.classList.remove('sa');
      pb.el.classList.remove('sb');
    }
    await G.wait(150);
  };

  G.onPick = async function (p) {
    var S = G.S, run = S.run;
    if (S.busy || S.phase !== 'pick') return;
    S.busy = true;
    S.phase = 'reveal';
    G.P.forEach(function (q) { q.el.disabled = true; q.el.onclick = null; });
    G.foot('locked');
    G.lift(p, true);
    if (p.t) {
      p.el.classList.add('win');
      G.sfx.win();
      G.say('CORRECT', G.pickOne(T.win));
      await G.wait(1100);
      if (alive(run)) G.cleared();
    } else {
      var c = G.P.filter(function (q) { return q.t; })[0];
      await G.wait(300);
      G.lift(c, true);
      c.el.classList.add('win');
      G.sfx.miss();
      G.say('NOT QUITE', G.pickOne(T.miss));
      await G.wait(1400);
      if (alive(run)) G.missed();
    }
  };

  G.cleared = function () {
    var S = G.S;
    S.cleared = S.level;
    G.track('level_reached', { level: S.level });
    if (S.cleared > G.best) { G.best = S.cleared; G.ls.set('sg_best', G.best); }
    if (S.level === 10) { G.renderRail(); G.end('legend'); return; }
    var t = G.tierAt(S.level);
    S.busy = false;
    if (t) {
      S.held = t;
      S.phase = 'reward';
      G.renderRail();
      G.sfx.reward();
      G.confetti();
      G.modalReward(t);
    } else {
      S.phase = 'decide';
      G.renderRail();
      if (S.held) G.say('DECIDE', 'Keep going, or take the prize?');
      G.foot('decide');
    }
  };

  G.next = function () {
    G.S.level++;
    G.playLevel();
  };

  G.missed = function () {
    var S = G.S;
    S.busy = false;
    S.phase = 'missed';
    if (!S.saveUsed) G.modalSave();
    else G.applyDrop();
  };

  G.applyDrop = function () {
    var S = G.S, prev = S.held;
    S.held = G.drop(prev);
    G.end(prev > 0 ? 'dropped' : 'nothing', prev);
  };

  G.useSave = async function () {
    var S = G.S;
    if (S.saveUsed) return;
    G.closeModal();
    await G.share('save');
    S.saveUsed = true;
    G.track('save_used', { level: S.level });
    G.playLevel();
    G.toast('Save used. Lock in this time.');
  };

  G.cash = function () {
    var S = G.S;
    if (S.busy || !S.held) return;
    G.track('cash_out', { held: S.held });
    G.end('cashed');
  };

  G.share = function (ctx) {
    var l = (G.S && G.S.cleared) || 0, u = G.C.shareUrl + '?sg=1';
    var title = T.title + ' by Sleek', text = 'I made it to Level ' + l + ' on ' + T.title + ". Bet you can't beat me.";
    G.track('share', { context: ctx });
    if (navigator.share) {
      return navigator.share({ title: title, text: text, url: u }).catch(function () {});
    }
    return G.copy(u).then(function () { G.toast('Link copied. Send it to a friend.'); });
  };

  G.copy = function (s) {
    function fb() {
      var ta = document.createElement('textarea');
      ta.value = s;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      ta.remove();
    }
    try {
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(s).catch(fb);
    } catch (e) {}
    fb();
    return Promise.resolve();
  };
})();
